import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useContext,
} from "react";
import "./style.scss";
import deleteIcon from "../../assets/images/deleteIcon.svg";
import {
  Table,
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
  Form,
  CloseButton,
  Image,
} from "react-bootstrap";
import moment from "moment";
import { TEAM, USER, STORAGE_BUCKET } from "../../config/endPoints";
import { httpGet, httpPost, httpDelete, httpPut } from "../../utils/http";
// import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { successToaster, errorToaster } from "../../components/Toaster";
import {
  TEAM_DELECTED,
  PENDING_INVITE_DELECTED,
  TEAM_UPDATED,
  TEAM_ADDED,
  TEAM_NAME,
  TEAM_MEMBER,
} from "../../config/generalMessage";
import Delete from "../../components/Modal/Delete";

function PendingInvit({ inviteTeamList, onDelete, userId }) {
  const [showDel, setDelShow] = useState(false);
  const [id, setId] = useState(null);
  const [inviteList, setInviteList] = useState(inviteTeamList);

  useEffect(() => {
    setInviteList(inviteTeamList);
  }, [inviteTeamList]);

  const DelClose = () => setDelShow(false);
  const DelShow = (id) => {
    setDelShow(true);
    setId(id);
  };

  const deleteTeam = async () => {
    await onDelete(id); // Call the delete function from the parent
    setDelShow(false); // Close the delete modal
  };

  return (
    <>
      {inviteTeamList.length > 0 ? (
        <>
          <ToastContainer autoClose={1000} />
          <div className="">
            <div className="TopBtn">
              <div className="d-flex justify-content-end"></div>
            </div>
            <div
              className="RoleWrap TeamWrap"
              style={{ margin: "20px 0", fontSize: "14px" }}
            >
              {/* <h2 style={{ margin: "20px 0" }}>
                Team Member Invitation Status
              </h2> */}
              <h3 className="mb-5">Team Member Invitation Status</h3>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Invite Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {inviteTeamList.map((item, index) => {
                    let createdAt = moment
                      .utc(new Date(item.createdAt))
                      .format("MMM Do YY");
                    return (
                      <tr key={index}>
                        <td>{item.email}</td>
                        <td>{item.role}</td>
                        <td className="">
                          <div className="d-flex justify-content-left">
                            {createdAt}
                          </div>
                        </td>
                        <td className="">
                          {item.status == 1 ? (
                            <p style={{ color: "red" }}>Declined</p>
                          ) : (
                            <p style={{ color: "orange" }}>Pending</p>
                          )}
                        </td>
                        <td>
                          {console.log(userId+'============'+item.createdBy)}
                          {userId == item.createdBy ? (
                            <OverlayTrigger
                              key={`tooltipd-${"top1"}`}
                              placement={"top"}
                              overlay={
                                <Tooltip id={`tooltipd-${"top1"}`}>
                                  Delete
                                </Tooltip>
                              }
                            >
                              <Button onClick={() => DelShow(item._id)}>
                                <img src={deleteIcon} alt="" />
                              </Button>
                            </OverlayTrigger>
                          ) : (
                            "N/A"
                          )}

                          {/* <OverlayTrigger
                            key={`tooltipd-${"top1"}`}
                            placement={"top"}
                            overlay={
                              <Tooltip id={`tooltipd-${"top1"}`}>
                                Delete
                              </Tooltip>
                            }
                          >
                            <Button onClick={() => DelShow(item._id)}>
                              <img src={deleteIcon} alt="" />
                            </Button>
                          </OverlayTrigger> */}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <Delete
                showDel={showDel}
                DelItem={deleteTeam}
                DelClose={DelClose}
                title="Do you want to delete team ?"
              />
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
}

export default PendingInvit;
